import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import router from '../router/index.js';

const url = "https://daijia.jia-zhi.cn/api_v3";
const configApi = {
	"passportLogin": "/passport/login",
	"console": "/console",
	"consoleLog": "/console/log",
	"consoleCost": "/console/cost",
	"consoleAmount": "/console/amount",
	"order": "/order",
	"orderMap": "/order/map",
	"orderPaylog": "/order/paylog",
	"orderDispatch": "/order/dispatch",
	"orderComment": "/order/comment",
	"driver": "/driver",
	"driverDel": "/driver/del",
	"driverJob": "/driver/job",
	"driverCoin": "/driver/coin",
	"driverCoope": "/driver/coope",
	"driverAmount": "/driver/amount",
	"user": "/user",
	"marketingStore": "/marketing/store",
	"marketingCoupon": "/marketing/coupon",
	"region": "/region",
	"regionSwitch": "/region/switchs",
	"regionCoin": "/region/coin",
	"regionAdmin": "/region/admin",
	"regionPrestige": "/region/prestige",
	"regionLocation": "/region/location",
	"operateConfig": "/operate/config",
	"operateCharging": "/operate/charging",
	"operateArea": "/operate/area",
	"operateAdmin": "/operate/admin",
	"total": "/total",
	"totalOrder": "/total/order",
	"totalDriver": "/total/driver",
	// "User": "/user",
	// "Driver": "/driver",
	// "Total": "/total",
	// "Operate": "/operate",
	// "Region": "/region",
	// "LongLink": "/longlink",
	// "Phone": "phone"
}

axios.defaults.baseURL = url;
axios.defaults.timeout = 30 * 1000;

export const apiurl = url;

export function post(api, param, headers) {
	const that = this;
	return new Promise((resolve, reject) => {
		headers = headers ? headers : {
			'Content-Type': 'application/x-www-form-urlencoded'
		};
		if (!param) {
			param = {};
		}
		let token = localStorage.getItem("_JIAZHI_token");
		if (token) {
			param['token'] = token;
		}
		axios.post(configApi[api], qs.stringify(param), {
			headers: headers
		}).then(res => {
			if (res.data.status === 200) {
				resolve(res.data);
			} else if (res.data.status === -100) {
				that.$message({
					message: res.data.message,
					type: "error",
					onClose: function() {
						localStorage.removeItem("_JIAZHI_token");
						localStorage.removeItem("_JIAZHI_info");
						router.push({
							path: "/login"
						});
					}
				});
			} else {
				reject(res.data);
			}
		}).catch(err => {
			reject(err.data);
		});
	});
};
